class InpageNavigation {

  constructor($main) {
    if (!this.initDomElements($main)) {
      return false;
    }

    this.initNavItems();

    this.initScrollWatch();
  }

  initDomElements($main) {
    this.domElements = {};
    this.domElements.main = $main;
    if (this.domElements.main.length < 1) return false;
    this.domElements.links = this.domElements.main.find('a');
    return true;
  }

  initNavItems() {
    this.navItems = [];
    this.domElements.links.each((index, item) => {
      const $item = $(item);
      const href = $item.attr('href');
      const id = href.substring(href.indexOf('#') + 1);
      // Cache the DOM element reference to avoid repeated queries
      const $element = $('#' + id);
      this.navItems.push({
        id: id,
        element: $item,
        domElement: $element.length > 0 ? $element[0] : null
      })
    });
  }

  initScrollWatch() {
    // Use Intersection Observer API for better performance
    const options = {
      root: null, // viewport
      rootMargin: '0px',
      threshold: 0.1 // trigger when at least 10% of the element is visible
    };

    // Create observers for each navigation item
    this.observers = [];

    this.navItems.forEach(item => {
      if (!item.domElement) return;

      const observer = new IntersectionObserver(entries => {
        entries.forEach(entry => {
          if (entry.isIntersecting) {
            this.domElements.links.removeClass('active');
            item.element.addClass('active');
          }
        });
      }, options);

      observer.observe(item.domElement);
      this.observers.push(observer);
    });

    // Fallback for browsers that don't support IntersectionObserver
    if (this.observers.length === 0) {
      this.initScrollWatchFallback();
    }
  }

  initScrollWatchFallback() {
    // Throttle function to limit execution frequency
    const throttle = (callback, delay) => {
      let lastCall = 0;
      return function() {
        const now = new Date().getTime();
        if (now - lastCall < delay) {
          return;
        }
        lastCall = now;
        return callback.apply(this, arguments);
      };
    };

    // Throttled scroll handler
    const handleScroll = throttle(() => {
      for (const item of this.navItems) {
        if (this.isElementInViewport(item)) {
          this.domElements.links.removeClass('active');
          item.element.addClass('active');
          break;
        }
      }
    }, 100); // Execute at most every 100ms

    document.addEventListener('scroll', handleScroll, {passive: true});
  }

  isElementInViewport(item) {
    if (!item.domElement) return false;

    const rect = item.domElement.getBoundingClientRect();
    return rect.top >= 0 && rect.bottom <= (window.innerHeight || document.documentElement.clientHeight);
  }
}

export default InpageNavigation;
